import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  Image
} from "react-bootstrap";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter } from "react-router";
import moment from "moment";
import isEmpty from "lodash.isempty";
import { getMerchantVoucherList } from "../../../redux/actions/voucherActions";
import activeImg from "../../../img/imgright.png";
import voidImg from "../../../img/imgwrong.png";
import { appConfig } from "../../../config";

import siteLogo from "../../../img/ddb-logo.png";

class Print extends Component {
  constructor(props) {
    super(props);
    this.state = {
      siteLogo: "",
      deal: "",
      voucherNumber: "",
      userName: "",
      lastName: "",
      direction: "DESC",
      orderBy: "createdOn",
      voucherNumberSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      lastNameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      createdOnSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
    };
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    let postData = {
      orderBy: orderBy,
      direction: direction,
      dealID: this.props.match.params.dealID,
      page: "0"
    };
    this.props.getMerchantVoucherList(postData);
  };

  componentWillMount() {
    let dealID = this.props.match.params.dealID
      ? this.props.match.params.dealID
      : "";

    let postData = {
      dealID: dealID,
      orderBy: this.state.orderBy,
      direction: this.state.direction,
      page: "0"
    };
    this.props.getMerchantVoucherList(postData);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.merchantVoucherList !== nextProps.merchantVoucherList) {
      if (nextProps.merchantVoucherList) {
        this.setState({
          voucherData: nextProps.merchantVoucherList.data,
          siteLogo: nextProps.merchantVoucherList.siteLogo,
          deal: nextProps.merchantVoucherList.dealText
        });
      }
    }
  }

  printDiv = () => {
    let divToPrint = document.getElementById("DivIdToPrint");

    let newWin = window.open("", "Print-Window");

    newWin.document.open();

    newWin.document.write(
      '<html><body onload="window.print()">' +
        divToPrint.innerHTML +
        "</body></html>"
    );

    newWin.document.close();
  };

  displayLogo() {
    if (this.state.themeData) {
      return this.state.themeData;
    } else {
      return siteLogo;
    }
  }

  render() {
    let voucherRow;
    let voucherListData = this.state.voucherData ? this.state.voucherData : "";
    if (!isEmpty(voucherListData) && this.state.dealID !== "") {
      voucherRow = voucherListData.map((voucher, index) => (
        <tr key={voucher.voucherID}>
          <td>
            {voucher.status == "Active" ? (
              <img
                src={activeImg}
                style={{ borderColor: "grey" }}
                width="30px"
              />
            ) : voucher.status == "Void" ? (
              <img src={voidImg} style={{ borderColor: "grey" }} width="30px" />
            ) : (
              ""
            )}
          </td>
          <td>{voucher.voucherNumber}</td>
          <td>{voucher.userName} </td>
          <td>{moment(voucher.createdOn).format("ll")}</td>
        </tr>
      ));
    }

    return (
      <div>
        <div className="row">
          <div className="col-lg-12 pull-right">
            <Button
                bsSize="small"
                className="pull-right"
                style={{backgroundColor: (this.state.hover && this.state.hoverID == 'order') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = 'order'
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                type="submit"
                onClick={this.printDiv.bind(this)}
              >
                <i className="glyphicon glyphicon-print" /> Print
              </Button>
          </div>
        </div>
        <div id="DivIdToPrint">
          <div className="row">
            <div className="col-lg-12">
              <table className="col-lg-12" width="100%">
                <tbody>
                  <tr>
                    <td align="center">
                      {" "}
                      <Image src={this.displayLogo()} width="20%" />{" "}
                    </td>
                  </tr>
                  <tr>
                    <td align="center"><b>{this.state.deal}</b></td>
                  </tr>
                  <tr>
                    <td align="center"><b>Voucher List</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="clearfix" />
          <hr />
          <div className="row">
            <div className="col-lg-12">
              <table className="table" width="100%">
                <thead>
                  <tr>
                    <th></th>
                    <th onClick={this.handleSort("voucherNumber")}>
                      Voucher Number{" "}
                     <span
                     className={this.state.voucherNumberSortIcon}
                     aria-hidden="true"
                     />{" "}
                    </th>
                   <th onClick={this.handleSort("lastName")}>
                    Customer{" "}
                    <span
                    className={this.state.lastNameSortIcon}
                    aria-hidden="true"
                    />{" "}
                   </th>
                   <th onClick={this.handleSort("createdOn")}>
                    Created On{" "}
                    <span
                    className={this.state.createdOnSortIcon}
                    aria-hidden="true"
                    />{" "}
                   </th>
                 </tr>
               </thead>
                <tbody>{voucherRow}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  merchantVoucherList: state.voucherReducer.merchantVoucherList,
  voucherStatus: state.voucherReducer.voucherStatus
});

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { getMerchantVoucherList })
)(Print);



// WEBPACK FOOTER //
// ./src/app/views/merchant/voucher/Print.js